module.exports = __webpack_public_path__ + "static/img/detailImgApple.9228e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgApple.png
// module id = /uGS
// module chunks = 6